import { useMemo } from "react"
import { useQuery } from "urql"

import { CompanyLegalInfoDocument } from "@/graphql/codegen/graphql"
import type { Company, Query } from "@/graphql/codegen/graphql"

interface UseCompanyLegalInfoProps {
  companyId: string
  pause?: boolean
}

const useCompanyLegalInfo = ({
  companyId,
  pause = false,
}: UseCompanyLegalInfoProps): {
  legalInfo: Company
  legalInfoFetching: boolean
  refetchLegalInfo: () => void
} => {
  const [{ data, fetching: legalInfoFetching }, executeQuery] = useQuery<Pick<Query, "company">>({
    query: CompanyLegalInfoDocument,
    variables: { companyId },
    pause: pause || !companyId,
  })

  const refetchLegalInfo = () => {
    executeQuery({ requestPolicy: "network-only" })
  }

  const legalInfoData = useMemo(() => {
    if (!data?.company?.get) {
      return []
    }
    return data.company.get.__typename === "CompanyGetSuccess" ? (data.company.get.company ?? []) : []
  }, [data]) as Company

  return {
    legalInfo: legalInfoData,
    legalInfoFetching,
    refetchLegalInfo,
  }
}

export default useCompanyLegalInfo
